import { Component, OnInit, ElementRef, ViewChild, Input, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { IUserDetails } from '../shared/models/UserDetailsOutputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { IBrokerRegionalLicenses } from '../shared/models/BrokerRegionalLicensesInputModel';
import { ValidationService } from '../shared/providers/validation.service';
import { IPropertySearchCriteria } from '../shared/models/propertysearchcriteria';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { PropertiesAssociatedOutputModel } from '../shared/models/PropertiesAssociatedOutputModel'
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { environment } from '../../environments/environment'
import { UserRole } from '../shared/enum/enum';
import { BrokerageManagerService } from '../shared/providers/brokerage-manager.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { PropertyListingService } from '../shared/providers/property-listing.service';
import { IUser } from '../shared/models/user';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AuthService } from '../shared/auth/auth.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
enum Tab {
  PersonalInformation = 1,
  ActivityLog = 2,
  InterestCriteria = 3,
  Notifications=4
}

@Component({
  selector: 'user-profiles',
  templateUrl: './profile-view.component.html',

})
export class UserProfileDetailsComponent {

  userDetailsOutput = {} as IUserDetails;
  brokerRegionalLicenses: Array<IBrokerRegionalLicenses> = [];
  userGuid: string = "";
  userId: number = 0;
  showPropertyAssociated: boolean = false;
  searchCriteria = {} as IPropertySearchCriteria;
  dtOptions = {};
  result = [];
  User = {} as any;
  CurrentPage: string = '';
  CurrentSourcePage: string = '';
  propertiesAssociated: PropertiesAssociatedOutputModel[];
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  modalRef: BsModalRef;
  ShowbrokerRegionalLicenses = false;
  @Input() userGuidToView: string = "";
  @Input() exchangeId: number = 0;
  @Input() exchangeOwner: number = 0;
  @Input() isExchangeAudit: boolean = false;
  @Input() isFromExchange1031: boolean = false;
  public currentuserid: number = 0;
  IsSeller = false;
  constructor(private propertyListing: PropertyListingService, public authService: AuthenticationService, private Authentication: AuthenticationService, private _brokerageManagerService: BrokerageManagerService, private _userManagerService: UserManagerService, private http: HttpClient, private activatedRoute: ActivatedRoute, private router: Router, public _validationService: ValidationService, private _auth0: AuthService, private modalService: BsModalService)
 {
  }
  callFromComponent = false;
  ngOnInit() {
    let loggedInUserGuid = '';
    let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
    if (loggedUserDetails == null || loggedUserDetails == undefined) {
      document.getElementById("openModalButton").click();
    }
    loggedInUserGuid = loggedUserDetails.Guid;
    this.User = this.authService.user;
    
    if (this._validationService.IsinValid(this.userGuidToView)) {
      this.activatedRoute.queryParams.subscribe((params: Params) => {
        this.userGuid = params['user']
        if (params['previouspage'] != null && params['previouspage'] != '') {
          this.CurrentPage = params['previouspage'];
        }
        if (params['sourcePage'] != null && params['sourcePage'] != '') {
          this.CurrentSourcePage = params['sourcePage'];
        }
      });
      if (loggedInUserGuid !== this.userGuid && this.userGuid != undefined) {
        this.router.navigate(['/']);
      }
    }
    else {
      this.userGuid = this.userGuidToView;
      this.callFromComponent = true;
    }
    if (this.userGuid == undefined && loggedInUserGuid != null && loggedInUserGuid != undefined) {
      this.userGuid = loggedInUserGuid;
    }
    if (this.userDetailsOutput.ProfilePicPath === undefined || this.userDetailsOutput.ProfilePicPath === null || this.userDetailsOutput.ProfilePicPath.trim().length <= 0) {
      this.userDetailsOutput.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
    }


    this._userManagerService.getUserDetails(this.userGuid).subscribe(response => {
      this.userDetailsOutput = response;
      this.currentuserid = response.Id;
      if (this.CurrentPage != '' && this.CurrentPage != null && this.CurrentPage == 'PrincipalDashboard') {
        this.activeTab = Tab.InterestCriteria;
        this.interest = true;
      }
      if (this.CurrentSourcePage != '' && this.CurrentSourcePage != null && this.CurrentSourcePage == 'PrincipalDashboard') {
        this.CurrentPage = 'PrincipalDashboard';
      }
      if (this.authService.Principal() || this.authService.Principal1031() || this.authService.Seller()) {
        this.userDetailsOutput.UserRole = "Principal";
        if (this.router.url.indexOf('user') <= -1) {
          this.activeTab = Tab.InterestCriteria;
          this.interest = true;
        }
      }
     
      if (this.userDetailsOutput.UserRoleId != UserRole.Principal && this.userDetailsOutput.UserRoleId != UserRole.Principal1031 && this.userDetailsOutput.UserRoleId != UserRole.Seller) {

        if (response.BrokerRegionalLicensesOutputModelList !== null) {
          //Converting  UTC Date into Local Date
          for (let i = 0; i < response.BrokerRegionalLicensesOutputModelList.length; i++) {
            let UTCDate = (response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate);
            var date = new Date(UTCDate + ' UTC');
            response.BrokerRegionalLicensesOutputModelList[i].ExpiryDate_Date = date;
          }
        }
        this.brokerRegionalLicenses = response.BrokerRegionalLicensesOutputModelList;
      }
      else {
        this.brokerRegionalLicenses = null;
      }
      if (this.userDetailsOutput.UserRoleId == 9) {
        this._userManagerService.getBrokerages(this.userDetailsOutput.Id).subscribe(response => {

          if (response != null) {
            this.result = response;
          }

        });
      }
      if (this.userDetailsOutput.UserRoleId == UserRole.Principal || this.userDetailsOutput.UserRoleId == UserRole.Principal1031) {

        this.searchCriteria.Guid = this.userGuid;
        //this.showPropertyAssociated = true;

        const that = this;
        this.dtOptions = {
          pagingType: 'full_numbers',
          serverSide: true,
          processing: true,
          info: false,
          language: {
            zeroRecords: null,
          },
          "pageLength": 50,
          bLengthChange: false,
          initComplete: () => $('.dataTables_filter').css('display', 'none'),
          ajax: (dataTablesParameters: any, callback: Function) => {
            dataTablesParameters.Extra_param = this.searchCriteria;
            const httpHeader = this._validationService.GetAuthHeader();
            that.http
              .post<DataTablesResponse>(
                this.BASE_URL + '/property/principalAssociatedPropertyList',
                dataTablesParameters, httpHeader
              ).subscribe(resp => {
                that.propertiesAssociated = resp.data ? resp.data : [];
                if (resp) {
                  callback({
                    recordsTotal: resp.recordsTotal,
                    recordsFiltered: resp.recordsFiltered,
                    data: []
                  });
                } else {
                  callback({
                    recordsTotal: 0,
                    recordsFiltered: 0,
                    data: []
                  });
                }
                $(".paginate_button.first,.paginate_button.last").hide();
              });
          },
          columns: [{ data: 'PropertyName' },
          { data: 'BrokerName' },
          { data: 'PropertyStatus' },
          { data: 'Price' },
          { data: 'CreditRating' },
          { data: 'CapRate' },
          { data: 'RemainingTerm' },
          { data: 'LeaseStructure' },
          { data: 'BuildingSize' }
          ]
        };
      }

      if (this.userDetailsOutput.ProfilePicPath === undefined || this.userDetailsOutput.ProfilePicPath === null || this.userDetailsOutput.ProfilePicPath.trim().length <= 0) {
        this.userDetailsOutput.ProfilePicPath = '/../../../assets/img/default-profile-img.png'
      }

      if (this.brokerRegionalLicenses != null) {
        if (this.authService.Admin() || this.authService.SuperAdmin() || this.authService.Broker()) {
          this.ShowbrokerRegionalLicenses = true;
        }
      }

      if (this.Authentication.Seller()) {
        this.IsSeller = true;
        this.GetTickersForThisUser();
      }
    });

  }


  tickers = [];
  private GetTickersForThisUser() {
    this.propertyListing.GetDefaultTickers(this.userDetailsOutput.Id).subscribe(res => {
      this.tickers = res;
    });
  }
  tab = Tab;
  interest:boolean=false
  activeTab = Tab.PersonalInformation;
  onTabClick(selectedTab) {
    if (selectedTab == 3) {
      this.interest = true;
    }
    else {
      this.interest = false;
    }
    this.activeTab = selectedTab;
    if (this.activeTab === Tab.PersonalInformation) {
      $(".dataTables_wrapper table thead").show();
    }
  }
  editUser() {
    this.router.navigate(['/edit-profile'], { queryParams: { user: this.userGuid.toString(), sourcepage: this.CurrentPage } });
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  onPrincipalDashboardClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

   openLoginModal(template: TemplateRef<any>, classes: any) {
     if (this.authService.isAuth0Enabled) {
       this._auth0.login();
    }
    else {
      this.modalRef = this.modalService.show(template, { class: classes });
    }
  };
}
